function setupVote(vote) {
  const form = vote.querySelector('form');
  const team = vote.querySelector('.vote_team');
  console.log('asd');
  if (team) {
    team.addEventListener('change', function (e) {
      checkInput(team)
    })
  }

  form.addEventListener('submit', function (e) {
    const teamValue = checkInput(team)
    e.preventDefault();
    if (teamValue) {
      nextPage(team);
    }
  });
}
